import * as React from 'react'

import { reaction } from 'mobx'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import RadioGroup from 'modules/core/components/Inputs/RadioGroup'
import i18n from 'modules/core/lib/i18n'

import DateRangePicker from 'modules/timeoff/components/DateRangePicker'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import { useContractsVersion } from 'modules/timeoff/lib/contractsVersionContext'
import { DaysTree } from 'modules/timeoff/lib/getDateRangeFromTree'
import { HALF_DAY_TYPES } from 'modules/timeoff/store/models/Leave'

import { useMinimumLeaveDate } from '../useMinimumLeaveDate'

export interface Props {
  form: LeaveForm
  holidays: DaysTree
  blockedPeriods: DaysTree
  existingLeaves: DaysTree
  readOnly?: boolean
}

const HalfDay = ({ form, holidays, blockedPeriods, readOnly, existingLeaves }: Props) => {
  const { startsOn } = useContractsVersion()
  const minDate = useMinimumLeaveDate(startsOn)

  React.useEffect(
    () =>
      reaction(
        () => form.get('start_on').value,
        (startOn) => form.get('finish_on').set(startOn)
      ),
    [form]
  )

  return (
    <>
      <FormRow>
        <DateRangePicker
          startDate={form.get('start_on')}
          endDate={form.get('finish_on')}
          readonly={!!readOnly}
          minDate={minDate.current}
          holidays={holidays}
          blockedPeriods={blockedPeriods}
          existingLeaves={existingLeaves}
          withNull={form.endDateOptional}
        />
      </FormRow>

      <FormRow>
        <RadioGroup
          name="halfDay"
          field={form.get('half_day')}
          options={[
            {
              value: HALF_DAY_TYPES.beggining_of_day,
              label: i18n.t('time_off.half_day_options.first_half'),
            },
            {
              value: HALF_DAY_TYPES.end_of_day,
              label: i18n.t('time_off.half_day_options.second_half'),
            },
          ]}
        />
      </FormRow>
    </>
  )
}

export default observer(HalfDay)
